// @flow
import React, { type Node } from 'react';
import { compose, pure } from 'recompose';
import { Button, Modal } from 'angieslist-react-components';
import { LightCloseIcon } from '@angi/icons';
import './MessageModal.scss';

type Props = {
  open: boolean;
  onClose: () => void;
  header: string;
  description: string;
  buttonText: string;
};

const MessageModal = ({
  open,
  onClose,
  header,
  description,
  buttonText,
}: Props): Node => (
  <Modal
    id="#message-modal-container--id"
    dialogClassName="angi-modal"
    show={open}
    onHide={onClose}
  >
    <Modal.Header
      id="message-header-container--id"
    >
      <Button
        id="message-close-button--id"
        className="message-close-button"
        bsStyle="link"
        onClick={onClose}
      >
        <LightCloseIcon />
      </Button>
    </Modal.Header>
    <Modal.Body>
      <Modal.Title className="National2-Bold">{header}</Modal.Title>
      <p className="National2-Regular modal-description">{description}</p>
    </Modal.Body>
    <Modal.Footer>
      <div className="modal-button-container">
        <Button
          id="message-modal--got-it-button"
          bsStyle="primary-office"
          className="message-modal-got-it-button National2-Bold"
          onClick={onClose}
          flat
          block
        >
          {buttonText}
        </Button>
      </div>
    </Modal.Footer>
  </Modal>
);

export default (compose(pure)(MessageModal): any);




// WEBPACK FOOTER //
// ./src/modules/home/browser/components/LeadCalculator/MessageModal.js